import * as  NavigationActions from './navigations.actions';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import { Navigation } from '@kion/data-models';

export const NAVIGATIONS_FEATURE_KEY = 'navigation';

export interface NavigationsState extends EntityState<Navigation> {
  error?: any;
  lastCreatedId: string|null;

  isSearching: boolean;
  searchResultIds: string[];
}

export const adapter: EntityAdapter<Navigation> = createEntityAdapter<Navigation>();

export interface NavigationsPartialState {
  readonly [NAVIGATIONS_FEATURE_KEY]: NavigationsState;
}

export const initialState: NavigationsState = adapter.getInitialState({
  lastCreatedId: null,
  isSearching: false,
  searchResultIds: [],
  searchQuery: {},
  pagination: {
    page: 1,
    perPage: 10,
    totalPages: 0,
    count: 0,
    total: 0
  }
});

const NavigationsReducer = createReducer(
  initialState,
  on(
    NavigationActions.loadAllSuccess,
    (state, { navigations  }) => adapter.upsertMany(navigations , { ...state })
  )
);

export function reducer(
  state: NavigationsState | undefined,
  action: Action
) {
  return NavigationsReducer(state, action);
}
